var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 42,
    viewBox: "0 0 77 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4135 8.68669L26.9066 14.5278L23.1657 5.65918L21.4135 8.68669Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5177 7.93787L31.7117 5.28479L31.0023 7.13553L33.5177 7.93787Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0708 0L0 4.20428L2.51543 5.78757L15.845 3.10239L16.0708 0Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2754 37.1752L19.962 19.1707L7.38489 25.1187L14.2754 37.1752Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9098 15.3623L19.4461 18.2507L20.0696 18.6465L27.1966 15.4799L16.189 3.74432L15.6192 7.54208L14.4798 15.0948L14.9098 15.3623Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0821 14.8487L15.2538 7.1141L15.7805 3.5517L0.171997 6.69688L14.0821 14.8487Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7804 3.5517L15.2536 7.1141L15.7804 3.5517Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5204 5.38107L27.5515 14.9664L31.2494 5.28479L23.5204 5.38107Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2749 3.20943L17.6724 4.69644L21.1015 8.35512L22.9182 5.23134L16.4684 0.353088L16.2749 3.01687L16.2964 3.00617L16.2749 3.20943Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2749 3.20935L17.6724 4.69636L16.2749 3.20935Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2752 3.20936L16.2967 3.0061L16.2752 3.0168L16.2644 3.19866L16.2752 3.20936Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6076 18.8604L14.996 15.9292L8.05167 24.3271L19.6076 18.8604Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2233 11.0831V29.8258H42.9449L42.9342 17.1702L41.225 29.8258H38.1828L36.3876 17.459L36.3769 29.8258H32.0985V11.0831H38.4408C38.6236 12.2063 38.8278 13.5436 39.0213 15.0734L39.72 19.8447L40.8487 11.0938H47.2233V11.0831Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0029 11.0831V14.838H63.6273V29.8365H58.7254V14.838H55.823V11.0831H66.0029Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0002 11.0831V14.838H74.087V29.8365H69.1851V14.838H66.8202V11.0831H77.0002Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3826 11.0831V29.8258H49.4808V11.0831H54.3826Z",
    fill: "#E9500E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8926 42H32.0019V31.8477H76.8926V42ZM37.882 40.6413H42.4183V39.6036H38.9569V33.3561H37.882V40.6413ZM48.8144 40.6413H49.9431L47.3632 33.3561H46.4602L43.8803 40.6413H45.0198L45.568 39.0152H48.2554L48.8144 40.6413ZM45.8905 38.031L46.9117 34.8431H46.9332L47.9544 38.031H45.8905ZM54.0495 37.6673H55.5007V38.0524C55.49 38.5124 55.3502 38.8762 55.0815 39.165C54.8127 39.4539 54.458 39.6036 54.0387 39.6036C53.7808 39.6036 53.5658 39.5501 53.383 39.4432C53.2003 39.3469 53.0498 39.2292 52.9315 39.0794C52.7918 38.919 52.695 38.7157 52.652 38.459C52.5983 38.2022 52.5768 37.7208 52.5768 37.004C52.5768 36.2873 52.5983 35.7952 52.652 35.5384C52.695 35.2924 52.7918 35.0891 52.9315 34.9286C53.0498 34.7789 53.1895 34.6505 53.383 34.5542C53.5658 34.4579 53.7808 34.4045 54.0387 34.3938C54.3827 34.4045 54.673 34.5007 54.9202 34.704C55.146 34.9073 55.3072 35.164 55.3932 35.4528H56.5327C56.4144 34.8431 56.1457 34.3296 55.7157 33.923C55.2857 33.5165 54.7267 33.3026 54.0387 33.3026C53.4798 33.3133 53.0175 33.4416 52.6413 33.7091C52.265 33.9765 51.9856 34.2761 51.8136 34.6077C51.7061 34.7896 51.6308 35.0142 51.5771 35.3031C51.5233 35.5919 51.5018 36.1589 51.5018 37.004C51.5018 37.8385 51.5233 38.4055 51.5771 38.6943C51.5986 38.8548 51.6308 38.9832 51.6738 39.0794C51.7168 39.1757 51.7598 39.2827 51.8136 39.3897C51.9856 39.7213 52.265 40.0208 52.6413 40.2776C53.0175 40.545 53.4798 40.6841 54.0387 40.6948C54.759 40.6841 55.361 40.4274 55.8339 39.946C56.3069 39.4539 56.5542 38.8441 56.5649 38.1166V36.6296H54.0387V37.6673H54.0495ZM59.0589 40.6413H63.5952V39.6036H60.1338V37.4534H63.09V36.4798H60.1338V34.3938H63.5952V33.3561H59.0589V40.6413ZM65.7989 40.6413H66.8739V37.5282H68.2498L69.7225 40.6413H71.0018L69.3571 37.4106C70.26 37.0575 70.7115 36.3836 70.7223 35.3887C70.7008 34.7147 70.4643 34.2012 70.0235 33.8375C69.6473 33.5165 69.1636 33.3561 68.5723 33.3561H65.7989V40.6413ZM66.8739 34.3296H68.5616C68.9056 34.3296 69.1743 34.4045 69.3571 34.5542C69.5828 34.7254 69.7118 35.0035 69.7118 35.378C69.7118 35.6989 69.615 35.9663 69.4108 36.1803C69.2066 36.4157 68.9056 36.5333 68.5078 36.544H66.8739V34.3296Z",
    fill: "#E9500E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9189f17c4f502cc593887952ebfa5928.svg";
export { ForwardRef as ReactComponent };